import { render, staticRenderFns } from "./addEffect.vue?vue&type=template&id=4fcc589e&scoped=true"
import script from "./addEffect.vue?vue&type=script&lang=js"
export * from "./addEffect.vue?vue&type=script&lang=js"
import style0 from "./addEffect.vue?vue&type=style&index=0&id=4fcc589e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc589e",
  null
  
)

export default component.exports